import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const StartedOnIcon = (props: SvgProps) => <Svg
  width='20'
  height='20'
  viewBox='0 0 20 20'
  fill='none'
  {...props}
>
  <Path
    d='M10.833 6.52706C10.833 6.06682 10.4599 5.69373 9.99965 5.69373C9.53942 5.69373 9.16632 6.06682 9.16632 6.52706V9.86039C9.16632 10.3206 9.53942 10.6937 9.99965 10.6937H13.333C13.7932 10.6937 14.1663 10.3206 14.1663 9.86039C14.1663 9.40016 13.7932 9.02706 13.333 9.02706H10.833V6.52706Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M9.99935 3.33268C6.31745 3.33268 3.33268 6.31745 3.33268 9.99935C3.33268 13.3996 5.87828 16.2053 9.16767 16.6146C9.62439 16.6715 9.99935 17.0391 9.99935 17.4993C9.99935 17.9596 9.62517 18.3371 9.16718 18.2917C4.95552 17.8741 1.66602 14.3209 1.66602 9.99935C1.66602 5.39698 5.39698 1.66602 9.99935 1.66602C14.3209 1.66602 17.8741 4.95552 18.2917 9.16718C18.3371 9.62518 17.9596 9.99935 17.4993 9.99935C17.0391 9.99935 16.6715 9.62438 16.6146 9.16767C16.2053 5.87828 13.3996 3.33268 9.99935 3.33268Z'
    fill={props.color ?? '#4A535A'}
  />
  <Path
    d='M17.0827 14.6943C17.6382 15.0151 17.6382 15.817 17.0827 16.1377L13.9577 17.9419C13.4021 18.2627 12.7077 17.8617 12.7077 17.2202V13.6118C12.7077 12.9703 13.4021 12.5694 13.9577 12.8901L17.0827 14.6943Z'
    fill={props.color ?? '#4A535A'}
  />
</Svg>;

export default StartedOnIcon;
